/** The organisation's time zone (fuel.md section 11.1 item 19). */
export const FUEL_TIME_ZONE = 'Asia/Amman';
const DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
export function isBusinessDate(value) {
    if (!DATE_PATTERN.test(value))
        return false;
    const parsed = new Date(`${value}T00:00:00Z`);
    return !Number.isNaN(parsed.getTime()) && parsed.toISOString().startsWith(value);
}
/** Today's calendar date in Asia/Amman: the start date of a branch on first use. */
export function todayInAmman(now = new Date()) {
    const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: FUEL_TIME_ZONE,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).formatToParts(now);
    const get = (type) => parts.find((p) => p.type === type)?.value ?? '';
    return `${get('year')}-${get('month')}-${get('day')}`;
}
/** The day after a business date: what a shift close moves the branch to. */
export function nextBusinessDate(date) {
    if (!isBusinessDate(date))
        throw new RangeError(`Not a business date: ${date}`);
    const next = new Date(`${date}T00:00:00Z`);
    next.setUTCDate(next.getUTCDate() + 1);
    return next.toISOString().slice(0, 10);
}
/**
 * The first instant of a calendar date in Asia/Amman, as UTC. Jordan keeps
 * UTC+3 all year, so a day runs from 21:00 UTC the day before.
 */
export function ammanDayStart(date) {
    if (!isBusinessDate(date))
        throw new RangeError(`Not a business date: ${date}`);
    return new Date(`${date}T00:00:00+03:00`);
}
/**
 * A real instant as `dd/MM/yyyy hh:mm AM|PM` in Asia/Amman (ticket of
 * 3 October 2026): Latin digits and Latin AM/PM whatever the language, with
 * `12:00 AM` at midnight and `12:00 PM` at noon. For human-readable strings
 * and exports; never for payloads, which stay ISO.
 */
export function formatAmmanDateTime(value) {
    const date = value instanceof Date ? value : new Date(value);
    const parts = new Intl.DateTimeFormat('en-US-u-nu-latn', {
        timeZone: FUEL_TIME_ZONE,
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h12',
    }).formatToParts(date);
    const get = (type) => parts.find((p) => p.type === type)?.value ?? '';
    return `${get('day')}/${get('month')}/${get('year')} ${get('hour')}:${get('minute')} ${get('dayPeriod').toUpperCase()}`;
}
/**
 * A list or export date cell: the business date (never shifted) followed by the
 * 12-hour Asia/Amman clock time of the instant, e.g. `28/09/2026 03:45 PM`.
 */
export function formatBusinessDateTime(businessDate, instant) {
    const [year, month, day] = businessDate.split('-');
    return `${day}/${month}/${year} ${formatAmmanDateTime(instant).slice(11)}`;
}
//# sourceMappingURL=business-date.js.map